/* @flow */
import * as React from 'react';

import BoxBody from 'components/BoxBody';
import Dialog from 'components/Dialog';
import TitleHeader from 'components/TitleHeader';
import QuickPromotion from 'entities/QuickPromotion';
import NumberInput from 'components/NumberInput';
import Button from 'components/Button';
import Field from 'components/Field';

const STUDENT_ID_LENGTH = 4;

class SisMergeExistingStudentModal extends React.Component<
  {
    promotion: QuickPromotion,
    onConfirm: (data: Object) => void,
    onDialogDismiss: () => any,
    onRequestHide: () => any,
  },
  $FlowFixMeState
> {
  state = {
    studentId: '',
  };
  handleConfirm = () => {
    this.props.onConfirm({ student_id: this.state.studentId });
    this.props.onRequestHide();
  };
  setStudentId = (studentId: string) => {
    this.setState({ studentId });
  };
  render() {
    const promotionData = this.props.promotion.getData();
    const expectedStudentIdLength =
      promotionData['student_id_matching_digits'] || STUDENT_ID_LENGTH;

    return (
      <Dialog
        eventScreenName="SisMergeExistingStudentModal"
        className="SisMergeExistingStudentModal"
        size="small"
        hideOnTransition={false}
        hideOnBlur={false}
        onDialogDismiss={this.props.onDialogDismiss}
        onRequestHide={this.props.onRequestHide}>
        <BoxBody>
          <TitleHeader
            title={this.props.promotion.getHeader()}
            subtext={this.props.promotion.getBody()}
            image={this.props.promotion.getImageUrl()}
          />
          <Field>
            <NumberInput
              name="student_id"
              placeholder="xxxx"
              value={this.state.studentId}
              onChange={this.setStudentId}
            />
          </Field>
          <Button
            full
            disabled={this.state.studentId.length !== expectedStudentIdLength}
            eventElementName="QuickPromotion-confirm"
            onClick={this.handleConfirm}>
            Submit
          </Button>
        </BoxBody>
      </Dialog>
    );
  }
}

export default SisMergeExistingStudentModal;
